import React, {Component} from 'react';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import classNames from "classnames";

class CompaniesList extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let {error, touched} = this.props.meta;
        return (
            <div className={classNames('form-group', 'row', {'has-danger': error&&touched})} id={`div_${this.props.input.name}`}>
                <label className="col-sm-2 col-form-label"><b>{this.props.label}</b></label>
                <div className='col-md-10'>
                    <Select
                        {...this.props}
                        value={this.props.input.value}
                        options={this.props.options}
                        onChange={(val) => this.props.input.onChange(val.value)}
                        multi={false}
                        clearable={false}
                        onBlur={() => this.props.input.onBlur(this.props.input.value)}
                    />
                    <div className={classNames('form-control-feedback', 'error-block', {'hidden-xs-up': !(error&&touched)})}>
                        {this.props.meta.error}
                    </div>
                </div>
            </div>
        );
    }
}

export default CompaniesList;


// WEBPACK FOOTER //
// ./web/src/components/users/CompaniesList.jsx